'use client'

import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useTimeRecordingStore } from '@repo/store/useTimeRecordingStore'

export const JCodePhaseTaskCodeSelect = ({
  testData = null,
  value = null,
  onChange = (val) => {
    console.log(val)
  },
  sx,
  menuZindex = 1100,
  menuWidth = null
}) => {
  const { fetchJCodePhaseTaskCodes, jCodePhaseTaskCodes } = useTimeRecordingStore()
  const [options, setOptions] = useState(testData || jCodePhaseTaskCodes || [])

  useEffect(() => {
    if (testData) return
    setOptions(jCodePhaseTaskCodes || [])
  }, [testData, jCodePhaseTaskCodes])

  useEffect(() => {
    if (testData || jCodePhaseTaskCodes.length) return
    fetchJCodePhaseTaskCodes()
  }, [testData, fetchJCodePhaseTaskCodes, jCodePhaseTaskCodes])

  return (
    <div
      data-testid="JCodePhaseTaskCodeSelect"
      style={{ width: sx?.width || '100%', maxWidth: sx?.maxWidth || '100%', minWidth: sx?.minWidth || '0' }}
    >
      <ReactSelectMenu
        label="Phase / task code"
        onChange={onChange}
        labelKey="name"
        valueKey="jCodePhaseTaskId"
        items={options}
        value={value}
        sx={{ width: '100%' }}
        searchable
        idLabelKey="jCodePhaseTaskCode"
        name="jCodePhaseTaskCode"
        menuZindex={menuZindex}
        menuWidth={menuWidth}
      />
    </div>
  )
}

JCodePhaseTaskCodeSelect.propTypes = {
  testData: PropTypes.array,
  value: PropTypes.object,
  onChange: PropTypes.func,
  sx: PropTypes.object,
  menuZindex: PropTypes.number,
  menuWidth: PropTypes.string
}
